import { NotificationsColorErrorBorder, NotificationsColorErrorBackground, NotificationsColorErrorText, NotificationsColorGeneralBorder, NotificationsColorGeneralBackground, NotificationsColorGeneralText, NotificationsColorSuccessBorder, NotificationsColorSuccessBackground, NotificationsColorSuccessText, NotificationsColorAlertBorder, NotificationsColorAlertBackground, NotificationsColorAlertText } from "@nxt-costco-com/forge-design-tokens";
import { NotificationTypes } from "./enums.js";
const ICON_SIZE = "20px";
const TEST_MESSAGE = 'Notification takes a message which (embedded HTML) and severity value.  4 types:  <strong>alert</strong>, <strong>general</strong>, <strong>success</strong>, & <strong>critical</strong>.  Please refresh the <a href="/">page</a>';
const COMPONENT_NAME = "Notification";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter`;
const INVALID_MESSAGE_ERROR = `${COMPONENT_NAME}-error: Unable to sanitize the message`;
const NOTIFICATION_COLOR_MAP = {
  [NotificationTypes.ALERT]: {
    color: NotificationsColorAlertText,
    backgroundColor: NotificationsColorAlertBackground,
    borderColor: NotificationsColorAlertBorder
  },
  [NotificationTypes.SUCCESS]: {
    color: NotificationsColorSuccessText,
    backgroundColor: NotificationsColorSuccessBackground,
    borderColor: NotificationsColorSuccessBorder
  },
  [NotificationTypes.GENERAL]: {
    color: NotificationsColorGeneralText,
    backgroundColor: NotificationsColorGeneralBackground,
    borderColor: NotificationsColorGeneralBorder
  },
  [NotificationTypes.CRITICAL]: {
    color: NotificationsColorErrorText,
    backgroundColor: NotificationsColorErrorBackground,
    borderColor: NotificationsColorErrorBorder
  }
};
export {
  COMPONENT_NAME,
  ICON_SIZE,
  INVALID_MESSAGE_ERROR,
  INVALID_PROPS_ERROR,
  NOTIFICATION_COLOR_MAP,
  TEST_MESSAGE
};
